export default __webpack_public_path__ + "static/media/notFoundBlueHouseLogo.2f538f39.svg";